import cn from 'clsx';

import skeletonStyles from '@/styles/Skeleton.module.css';
import styles from './FloorPlanImageSlider.module.css';

export const FloorPlanPlaceholder = () => <div className={cn(styles.placeholder, skeletonStyles.skeleton)} />;
